import IOrder from "../types/IOrder";
import { Order } from "../models/Order";
import Store from "./Store";
import { makeObservable, runInAction } from "mobx";
import AppStore from "./AppStore";

export default class OrderStore extends Store<IOrder, Order> {
  items = new Map<string, Order>();

  constructor(store: AppStore) {
    super(store);
    makeObservable(this, {
      items: true,
      selected: true,
    });
    this.store = store;
  }

  load(items: IOrder[] = []) {
    runInAction(() => {
      items.forEach((item) =>
        this.items.set(item.id, new Order(this.store, item))
      );
    });
  }
}
